import { WriteLocationForm } from "../WriteLocationForm";

export interface AddLocationProps {}

export const AddLocation = () => {
  return <WriteLocationForm />;
};
